import React, { useState } from "react";
import Floaticons from "./Floaticons";
import "./HomeContent.css";
import Leadershipcarousel from "./Leadershipcarousel";
import LearningsTab from "./LearningOfferingTab";
function HomeContent() {
  const [isActiveRole, setIsActiveRole] = useState(false);
  const [isActiveTech, setIsActiveTech] = useState(false);
  return (
    <>
      <div className="main-banner">
        <img src="images/Home/EnbridgeMainbanner-New.png" alt="banner" className="banner-img" />
        {/* <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" /> */}
        <div className="announcemnt-box">
          <p>
            <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
            <marquee
              width="92%"
              direction="left"
              style={{ display: "inline-block", verticalAlign: "middle" }}
            >
              <b>Come Join Us</b> on an exhilarating learning Journey on Enbridge Talent Academy
              Platform!!!
            </marquee>
          </p>
        </div>
        <Floaticons />
      </div>
      {/* section1 */}
      <div className="sodexo-container">
        <div className="sodexo-wrap">
          <div className="sodexo-about-box">
            <h2> About Enbridge Talent Academy</h2>
          </div>
          <div className="sodexo-row row1">
            <div className="sodexo-box">
              {/* <h4 style={{ marginBottom: "20px", color: "#2a23a3;" }}>
                Anchor Knowledge on Main Tech Areas, Strategic for Sodexo
              </h4> */}

              <p>
                <b>Enbridge Talent Academy</b> has been conceptualized as a comprehensive platform to
                offer end-to-end learning experiences through personalized learning pathways
                curated by experts at Accenture and Enbridge. It encompasses continuous{" "}
                <b>mandatory, process-based and skill-based learning</b>, assessments, certifications, and
                mentorship on the niche and future skills. It is a significant step towards
                building a future-ready talent - a talent geared up to scale Enbridge's business
                transformation goals and achieve its Net Zero emission target by 2050.
              </p>
            </div>
          </div>
          <div className="sodexo-row row2">
            <div className="sodexo-box">
              <img
                src="images/Home/AboutSodexoTalentAcademy-Video.png"
                alt="video"
                className="video-img"
              />
            </div>
          </div>
        </div>
        {/* <img
          src="images/Home/banner-strip.png"
          alt="strip"
          className="strip-img1"
        /> */}
      </div>
      {/* section2 */}
      <div className="learning-outside" id="LearningOfferings">
        <div className="learning-container">
          <div className="learning-container-box">
            <h2>Learning Offerings</h2>
          </div>
          <p className="learns-text">
            Enbridge Talent Academy offers mandatory, process-based and skill-based learning offerings to suit
            one's specific learning needs.
          </p>
          <LearningsTab />
        </div>
      </div>
      <div className="infographics-container">
        <div className="infographic-wrapper">
          <div className="infographics-box">
            <h2>Learning Journey</h2>
          </div>
          <div className="infographics-img">
            <img src="images/Home/Home-Infographics.png" alt="Home-Infographics" />
          </div>
        </div>
      </div>
      <div className="leadership-container">
        <div className="leadership-wrap">
          <div className="leadership-box">
            <h2>Leadership Message</h2>
          </div>
          <Leadershipcarousel />
        </div>
      </div>
    </>
  );
}

export default HomeContent;
